import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/mentorship-video-img.png")